var xhrTypeAheadSearch = null;
jQuery.fn.typeaheadSearch = function () {
    $('<select/>', { 'id': 'typeahead-result' }).appendTo('#typeAheadResultDiv');
    var $res = $('#typeahead-result');
    $res.hide();

    $('#page .container, #nav-main').mouseover(function () {
        $('#input-search').removeClass('results-expanded');
        $res.fadeOut('fast');
    });


    $(this).on('keyup', function (e) {
        var nav = false;
        var v = $(this).val();

        var MachineType = $('#MachineType').val();

        // Handling starting characters that can break the ajax 
        v = encodeURIComponent(v);
        e.preventDefault();
        // escape key
        if (e.keyCode == 27) {
            $res.html('');
            return;
        }
        // enter key
        if (e.keyCode == 13) {
            nav = true;
        }
        
         if (v.length >= 3 && nav == false) {
            if (xhrTypeAheadSearch && xhrTypeAheadSearch.readyState != 4) {
                xhrTypeAheadSearch.abort();
            }

            xhrTypeAheadSearch = $.ajax({
                url: '/Base/ClaimReportServices/TypeAheadSpareParts/' + encodeURI(MachineType) + '/' + encodeURI(v) + '/' + encodeURI(twoLetterIsoLanguageName), dataType: 'json',
                success: function (obj) {
                    $("#typeAheadResultDiv").show();
                    $('#input-search').addClass('results-expanded');
                    $('#typeahead-result').addClass('show-results');

                    var resultHTM = '';

                    for (var i = 0; i < obj.parts.length; i++) {
                        var item = obj.parts[i];
                        var partDesc = item.name;
                        if (item.name.length > 29) {
                            partDesc = partDesc.substr(0, 26) + '&#133;';
                        }
                        resultHTM += '<option value="' + item.partnumber + ': ' + partDesc + ' - ' + item.standardtime + '">' + item.partnumber + ': ' + partDesc + ' - ' + item.standardtime + '</option>';
                    }
                    if (obj.parts.length > 0) {
                        $res.show();
                    } else {
                        $res.hide();
                    }

                    $res.html(resultHTM);
                    $res.attr('size', '7');

                    //$res.find('li').each(function(){
                    //    var item = $(this);
                    //    $(item).on("click", function () {
                    //        console.log(item.text());
                    //        $("#SparePartNumberInput").val(item.text());
                    //        //$('#input-search').removeClass('results-expanded'); $('#typeahead-result').removeClass('show-results'); $("#typeAheadResultDiv").hide();
                    //    });
                    //    //$(item).on("mouseover", function () {
                    //    //    $(item).addClass('typeahead-result-over');
                    //    //});
                    //    //$(item).on("mouseout", function () {
                    //    //    $(item).removeClass('typeahead-result-over');
                    //    //});

                    //});

                    $res.on("change", function () {
                        var $this = $(this),
                            selectVal = $this.val();

                        $("#SparePartNumberInput").val(selectVal).change();

                        setTimeout(function() {
                            $res.hide();
                        }, 400);

                    });
                }
            });
        }
        else {
            $res.html('');
            $res.attr('size', '0');
            $res.hide();
        }

    });
    
};